<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventParticipants"
        title-table="Participantes do Evento"
        module="eventParticipantSettingsModule"
        sort-name="registro.nome"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <EventParticipantForm v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import EventParticipantForm from "./form/EventParticipantForm.vue";

export default {
  name: "EventParticipantSetting",
  components: {
    BRow,
    BCol,
    TableComponents,
    EventParticipantForm,
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: "ID",
          field: "id",
          width: "80px",
        },
        {
          label: "Evento",
          field: "evento.nome",
        },
        {
          label: "Participante",
          field: "registro.nome",
        },
        {
          label: "Inscrito em",
          field: "inscritoEm",
          formatter: (value) => {
            if (!value) return "-";
            const date = new Date(value);
            return date.toLocaleString("pt-BR");
          },
        },
      ],
    };
  },
  computed: {
    ...mapState("eventParticipantSettingsModule", {
      listaEventParticipants: (state) => state.listaEventParticipants,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch("eventParticipantSettingsModule/reset");
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "eventParticipantSettingsModule/prepareToEdit",
        data
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
      this.$store.dispatch("eventParticipantSettingsModule/reset");
    },
  },
};
</script>
